import { useState } from "react";
import { Button, Modal, Form, Input } from "antd"
import { PlusOutlined } from "@ant-design/icons"
import CategoryForm from "./form/CategoryForm";
import { categoryRegisterAsync } from "../../../app/store/reducers/category/categoryReducer";



const RegisterCategoryModal = () => {
  const [form] = Form.useForm()
  const [show, setShow] = useState(false);
  const showModal = () => {
    setShow(true);
  };
  const handleCancel = () => {
    setShow(false);
    form.setFieldValue("name", "")
  };

  const onSubmit = async (values) => {
    await categoryRegisterAsync(values)
      .then((response) => {
        console.log("success reg category", response.data);
        handleCancel()
      })
      .catch((error) => {
        console.log(error);
      })
  }

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        onSubmit(values)
        form.resetFields();
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };


  return (
    <>
      <Button type="primary" className="d-flex align-items-center justify-content-center" onClick={showModal}>
        <PlusOutlined /> Add
      </Button>
      <Modal 
        title="Register Category" 
        open={show} 
        okText="Add"
        cancelText="Cancel"
        onOk={handleOk} 
        onCancel={handleCancel}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={onSubmit}
        >
          <CategoryForm/>
        </Form>
      </Modal>
    </>
  );
}

export default RegisterCategoryModal